// @ts-nocheck
/* eslint-disable react/forbid-prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Chip, Divider, TextField, Typography } from '@mui/material';
import { isEmpty, includes } from 'lodash';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import PropTypes from 'prop-types';

import { ReactComponent as DropdownArrow } from '../../assets/images/DropdownArrow.svg';
import { DropDown, DropdownItem } from './DropDown';
import utils from '../../utils/utils';

const SELECT_ALL = 'Select all';
const SELECT_ALL_COLUMN = {
  label: SELECT_ALL,
  value: SELECT_ALL,
  column_name: SELECT_ALL,
};

const columnGetOptionLabel = (option) => {
  return option.column_name ? option.column_name : '';
};

const columnIsOptionEqualToValue = (option, value) => {
  return option.column_name === value.column_name;
};

const freeSoloIsOptionEqualToValue = (option, value) => {
  return option.value === value.value;
};

const consoleFileIsOptionEqualToValue = (option, value) => {
  return option?.id
    ? option?.id === value?.id
    : option?.file_id === value?.file_id;
};

const datasetGetOptionLabel = (option) => {
  if (
    option?.table_display_name &&
    !option?.argumentsFromPipeline &&
    !option?.argumentsFromParentPipeline
  ) {
    return utils.getDisplayName(option, 'table');
  }
  if (option?.argumentsFromPipeline || option?.argumentsFromParentPipeline) {
    return utils.getDisplayName(option, 'pipeline');
  }
  return '';
};
const consoleFileGetOptionLabel = (option) => {
  if (
    option?.name &&
    !option?.argumentsFromPipeline &&
    !option?.argumentsFromParentPipeline
  ) {
    return utils.formatConsoleFileDisplayName(option, 'consoleFile');
  }
  if (option?.argumentsFromPipeline || option?.argumentsFromParentPipeline) {
    return utils.formatConsoleFileDisplayName(option, 'pipeline');
  }
  return '';
};

const modelIsOptionEqualToValue = (option, value) => {
  return value.modelId
    ? option.modelId === value.modelId
    : option.id === value.id;
};

const argsFreesoloRenderOption = (optionProps, option, index) => (
  <Box
    display="flex"
    flexGrow={1}
    alignItems="center"
    textOverflow="ellipsis"
    {...optionProps}
    key={index}
  >
    <Box display="flex" flexGrow={1} textOverflow="ellipsis" width={5} pr={2}>
      {option?.argumentsFromParentPipeline || option?.argumentsFromPipeline ? (
        <Typography
          noWrap
          textOverflow="ellipsis"
          overflow="hidden"
          style={{ maxWidth: '60%' }}
          variant="body2"
        >
          {option?.name}
        </Typography>
      ) : (
        <Typography
          noWrap
          textOverflow="ellipsis"
          overflow="hidden"
          style={{ maxWidth: '60%' }}
          variant="body2"
        >
          {option?.value}
        </Typography>
      )}
    </Box>
    {/* for pipeline arguments */}
    {option?.argumentsFromPipeline ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography
          variant="caption"
          noWrap
          width={175}
          title={option?.parentPipelineName}
          textOverflow="ellipsis"
        >
          Pipeline argument : {option?.parentPipelineName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
    {/* for Parent pipeline arguments */}
    {option?.argumentsFromParentPipeline ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography
          variant="caption"
          noWrap
          width={175}
          title={option?.parentPipelineName}
          textOverflow="ellipsis"
        >
          Parent pipeline argument : {option?.parentPipelineName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
  </Box>
);

const AutocompleteFreeSolo = ({
  type,
  handleBlur,
  label,
  placeholder,
  additionalPipelineArguments,
  form,
  argIndex,
}) => {
  const [combinedArglist, setCombinedArgumentsList] = useState({});
  const filterAndCombine = (pipelineArgumentsArray, additionalArguments) => {
    const combinedArray = {
      String: [],
      Float: [],
      Int: [],
      Boolean: [],
      Dataset: [],
      ...additionalArguments,
    };
    pipelineArgumentsArray?.forEach((ele) => {
      const typeValue = ele?.type?.value;
      if (['String', 'Float', 'Int', 'Boolean'].includes(typeValue)) {
        combinedArray[typeValue].push(ele);
      }
    });
    const removeDuplicates = (_type) => {
      const uniqueSet = new Set();
      // eslint-disable-next-line no-underscore-dangle
      combinedArray[_type] = combinedArray[_type].filter((ele) => {
        const uniqueKey = JSON.stringify(ele);
        if (!uniqueSet.has(uniqueKey)) {
          uniqueSet.add(uniqueKey);
          return true;
        }
        return false;
      });
    };

    ['String', 'Float', 'Int', 'Boolean'].forEach(removeDuplicates);

    delete combinedArray.Dataset;
    delete combinedArray.Model;
    delete combinedArray.Column;
    delete combinedArray.ConsoleFile;

    setCombinedArgumentsList(combinedArray);
    return combinedArray;
  };

  function removeMatchingObjects(arr) {
    return arr.filter((obj, index, self) => {
      return !self.some(
        (otherObj, otherIndex) =>
          index !== otherIndex && obj.value.value === otherObj.value
      );
    });
  }

  useEffect(() => {
    filterAndCombine(form?.values?.args, additionalPipelineArguments);
  }, []);

  const getOptionLabelArgsFreeSolo = useCallback((option) => {
    if (
      option?.argumentsFromParentPipeline ||
      (option?.argumentsFromPipeline && option?.name)
    ) {
      return option?.name;
    }
    // Value selected with enter, right from the input
    if (typeof option === 'string' || typeof option === 'number') {
      return option;
    }
    // Add "xxx" option created dynamically
    if (typeof option.value === 'number') {
      return String(option.value);
    }
    if (typeof option.value === 'string') {
      return String(option.value);
    }
    // Regular option
    return '';
  }, []);

  const filterdOps = createFilterOptions();
  return (
    <>
      <Autocomplete
        options={
          combinedArglist?.[type]?.length
            ? removeMatchingObjects(combinedArglist?.[type])?.map((ele) => {
                if (typeof ele?.value === 'object') {
                  return {
                    ...ele,
                    value: ele?.value?.value,
                  };
                }
                return ele;
              })
            : []
        }
        freeSolo={form?.values?.args[argIndex]?.type !== 'Boolean'}
        renderOption={argsFreesoloRenderOption}
        popupIcon={<DropdownArrow />}
        getOptionLabel={getOptionLabelArgsFreeSolo}
        disableClearable={
          ['', undefined, {}].includes(form?.values?.args[argIndex]?.value) ||
          isEmpty(form?.values?.args[argIndex]?.value)
        }
        filterOptions={(options, params) => {
          const filtered = filterdOps(options, params);
          const { inputValue } = params;
          // Suggest the creation of a new value
          const isExisting = options.some(
            (option) => inputValue === option.title
          );
          if (inputValue !== '' && !isExisting) {
            filtered.push({
              inputValue,
              label: `Add "${inputValue}"`,
              value: inputValue,
              title: `Add "${inputValue}"`,
            });
          }

          return filtered;
        }}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            form.setFieldValue(`args.${argIndex}.value`, {
              ...event,
              label: newValue,
              value: newValue,
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            form.setFieldValue(`args.${argIndex}.value`, {
              ...event,
              label: newValue.inputValue,
              value: newValue.inputValue,
            });
          } else {
            form.setFieldValue(`args.${argIndex}.value`, newValue);
          }
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        noOptionsText="No values available to select."
        isOptionEqualToValue={freeSoloIsOptionEqualToValue}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              onBlur={handleBlur}
              label={label}
              placeholder={placeholder}
              name={`args.${argIndex}.value`}
              InputLabelProps={{
                shrink: true,
              }}
              helperText={
                form?.touched?.args?.[argIndex]?.value &&
                form?.errors?.args?.[argIndex]?.value
                  ? form?.errors?.args?.[argIndex]?.value
                  : null
              }
              error={
                Boolean(form?.errors?.args?.[argIndex]?.value) &&
                form?.touched?.args?.[argIndex]?.value
              }
            />
          );
        }}
        value={
          form?.values?.args?.[argIndex]?.value &&
          typeof form?.values?.args?.[argIndex]?.value === 'object'
            ? form?.values?.args?.[argIndex]?.value
            : form?.values?.args?.[argIndex]?.value
        }
      />
    </>
  );
};

AutocompleteFreeSolo.defaultProps = {
  datasetColumns: [],
  label: '',
  placeholder: '',
  sx: {},
};
AutocompleteFreeSolo.propTypes = {
  // argValue,
  type: PropTypes.string.isRequired,
  datasetColumns: PropTypes.oneOfType([PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  sx: PropTypes.objectOf(PropTypes.any),
  helperText: PropTypes.objectOf(PropTypes.any).isRequired,
  error: PropTypes.objectOf(PropTypes.any).isRequired,
  handleBlur: PropTypes.func.isRequired,
  activeProject: PropTypes.oneOfType([PropTypes.object]).isRequired,
  form: PropTypes.oneOfType([PropTypes.array]).isRequired,
  argIndex: PropTypes.string.isRequired,
  additionalPipelineArguments: PropTypes.oneOfType([PropTypes.object])
    .isRequired,
  name: PropTypes.string.isRequired,
};

const consoleFileRenderOption = (optionProps, option, index) => (
  <Box
    display="flex"
    flexGrow={1}
    alignItems="center"
    textOverflow="ellipsis"
    {...optionProps}
    // @ts-ignore
    key={index}
  >
    <Box display="flex" flexGrow={1} textOverflow="ellipsis" width={10} pr={2}>
      <Typography noWrap>{option.name}</Typography>
    </Box>
    {/* for pipeline node */}
    {option.outputFromPrevNode ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography variant="caption">
          Output from previous node : {option?.prevNodeName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
    {/* for pipeline argument */}
    {option.argumentsFromPipeline ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography variant="caption">
          Pipeline argument : {option?.parentPipelineName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
    {/* for pipeline argument */}
    {option.argumentsFromParentPipeline ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography variant="caption">
          Parent pipeline argument : {option?.parentPipelineName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
  </Box>
);
const datasetRenderOption = (optionProps, option, index) => (
  <Box
    key={index}
    display="flex"
    flexGrow={1}
    alignItems="center"
    textOverflow="ellipsis"
    overflow="hidden"
    {...optionProps}
  >
    <Box display="flex" flexGrow={1} textOverflow="ellipsis" pr={1}>
      <Typography
        width="70%"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        title={option?.table_display_name}
      >
        {option?.table_display_name}
      </Typography>
    </Box>
    {/* for pipeline node */}
    <Box display="flex" alignItems="center" gap={1}>
      {option?.outputFromPrevNode ? (
        <Typography
          variant="caption"
          noWrap
          title={option?.parentPipelineName}
          textOverflow="ellipsis"
        >
          Output from previous node : {option?.prevNodeName}
        </Typography>
      ) : null}
      {/* for pipeline argument */}
      {option?.argumentsFromPipeline ? (
        <Typography
          variant="caption"
          noWrap
          title={option?.parentPipelineName}
          textOverflow="ellipsis"
        >
          Pipeline argument : {option?.parentPipelineName}
        </Typography>
      ) : null}
      {/* for pipeline argument */}
      {option?.argumentsFromParentPipeline ? (
        <Typography
          variant="caption"
          noWrap
          title={option?.parentPipelineName}
          textOverflow="ellipsis"
        >
          Parent pipeline argument : {option?.parentPipelineName}
        </Typography>
      ) : null}
    </Box>
  </Box>
);

const columnRenderOption = (optionProps, option, index) => (
  <Box
    display="flex"
    flexGrow={1}
    alignItems="center"
    textOverflow="ellipsis"
    {...optionProps}
    // @ts-ignore
    key={index}
  >
    <Box display="flex" flexGrow={1} textOverflow="ellipsis" width={10} pr={2}>
      <Typography noWrap>{option.column_name}</Typography>
    </Box>
    <Box display="flex" alignSelf="flex-end">
      <Typography variant="caption">{option?.data_type}</Typography>
      <Divider
        orientation="vertical"
        flexItem
        style={{ marginRight: 5, marginLeft: 5 }}
      />
      <Typography variant="caption">{option?.type}</Typography>
    </Box>
  </Box>
);

const modelRenderOption = (optionProps, option, index) => (
  <Box
    display="flex"
    flexGrow={1}
    alignItems="center"
    textOverflow="ellipsis"
    {...optionProps}
    // @ts-ignore
    key={index}
  >
    <Box display="flex" flexGrow={1} textOverflow="ellipsis" width={10} pr={2}>
      <Typography
        variant="body2"
        width="70%"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {option.model_name
          ? `${option.model_name} (${option.model_technique_label})`
          : ''}
      </Typography>
    </Box>
    {option?.is_logical ? (
      <Box display="flex" alignSelf="flex-end" pr={1}>
        <Typography variant="caption">Logical model</Typography>
      </Box>
    ) : (
      ''
    )}
    {option?.external_pkl ? (
      <Box display="flex" alignSelf="flex-end" pr={1}>
        <Typography noWrap variant="caption">
          External
        </Typography>
      </Box>
    ) : (
      <Box display="flex" alignSelf="flex-end" pr={1}>
        <Typography noWrap variant="caption">
          Internal
        </Typography>
      </Box>
    )}
    {/* for pipeline node */}
    {option.outputFromPrevNode ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography variant="caption">
          Output from previous node : {option?.prevNodeName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
    {/* for pipeline arguments */}
    {option?.argumentsFromPipeline ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography variant="caption">
          Pipeline argument : {option?.parentPipelineName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
    {/* for pipeline arguments */}
    {option?.argumentsFromParentPipeline ? (
      <Box display="flex" alignSelf="flex-end">
        <Typography variant="caption">
          Parent pipeline argument : {option?.parentPipelineName}
        </Typography>
      </Box>
    ) : (
      ''
    )}
  </Box>
);

/**
 * @function ConsoleArgumentInput
 * @description It renders the console argument input
 * @param {object} props - props object
 * @param {string} type - type of input
 * @param {string} helperText - helper text
 * @param {boolean} error - error
 * @param {array} datasetColumns - dataset columns
 * @param {array} allDatasets - all datasets
 * @param {array} models - all models
 * @param {function} onChange - on change function
 * @param {function} fetchConsoleFileList - to fetch all console files
 * @param {object} activeProject - active project
 * @returns {object} - returns a jsx object
 */
export default function ConsoleArgumentInput({
  type,
  datasetColumns = [],
  onChange,
  helperText,
  error,
  allDatasets = [],
  models = [],
  consoleFilesList = [],
  activeProject,
  handleBlur,
  label,
  placeholder,
  additionalConsoleFilesFromPipelineArguments = [],
  additionalPipelineArguments,
  argValue,
  argIndex,
  form,
  ...props
}) {
  const regex = /^pipeline_args\((\w+),\s*(\w+)(?:,\s*([\w\d]+))?\)$/;
  const columnsOnChange = useCallback(
    (_event, value) => {
      if (includes(value, SELECT_ALL_COLUMN)) {
        onChange({
          target: {
            value: datasetColumns?.filter((col) => col?.column_name !== 'pk'),
          },
        });
      } else {
        onChange({ target: { value } });
      }
    },
    [onChange]
  );

  const renderInput = useCallback(
    (params) => (
      <TextField
        {...params}
        onBlur={handleBlur}
        name="value"
        error={error}
        helperText={helperText}
        label={label}
        placeholder={placeholder}
        InputLabelProps={{
          shrink: true,
        }}
      />
    ),
    [error, helperText, label, placeholder]
  );

  const boolOptions = [
    {
      value: 'true',
      type: 'Boolean',
    },
    {
      value: 'false',
      type: 'Boolean',
    },
  ];

  const isDatastetOptionEqualToValue = (option, val) => {
    if (val?.dataset_id && option?.dataset_id) {
      return option?.dataset_id === val?.dataset_id;
    }
    if ((val?.dataset_id && option?.id) || (val?.id && option?.dataset_id)) {
      return false;
    }
    return option?.id === val?.id;
  };

  // Column, String, Number, Boolean, List
  switch (type) {
    case 'Int':
    case 'Float':
      return (
        <>
          {!additionalPipelineArguments?.[type]?.length ? (
            <TextField
              onChange={onChange}
              name="value"
              onBlur={handleBlur}
              helperText={helperText}
              error={error}
              type="number"
              label={label}
              placeholder={placeholder || `Enter ${type}`}
              {...props}
              value={!regex.test(props.value) ? props.value : ''}
            />
          ) : (
            <AutocompleteFreeSolo
              type={type}
              onChange={onChange}
              error={error}
              handleBlur={handleBlur}
              label={label}
              helperText={helperText}
              placeholder={placeholder}
              additionalPipelineArguments={additionalPipelineArguments}
              argValue={argValue}
              form={form}
              argIndex={argIndex}
              name="value"
              {...props}
            />
          )}
        </>
      );
    case 'String':
      return (
        <>
          {!additionalPipelineArguments?.[type]?.length ? (
            <TextField
              onChange={onChange}
              name="value"
              onBlur={handleBlur}
              helperText={helperText}
              error={error}
              label={label}
              placeholder={placeholder || 'Enter text/string'}
              {...props}
              value={!regex.test(props.value) ? props.value : ''}
            />
          ) : (
            <AutocompleteFreeSolo
              type={type}
              onChange={onChange}
              error={error}
              handleBlur={handleBlur}
              label={label}
              placeholder={placeholder}
              additionalPipelineArguments={additionalPipelineArguments}
              argValue={argValue}
              form={form}
              argIndex={argIndex}
              name="value"
            />
          )}
        </>
      );
    case 'List':
      return (
        <TextField
          onChange={onChange}
          name="value"
          onBlur={handleBlur}
          helperText={helperText}
          error={error}
          label={label}
          placeholder={placeholder}
          {...props}
        />
      );
    case 'Boolean':
      return (
        <>
          {!additionalPipelineArguments?.[type]?.length ? (
            <Box mt={2}>
              <DropDown
                label={label}
                name="value"
                helperText={helperText}
                error={error}
                placeholder={placeholder || 'Select option'}
                onChange={onChange}
                onBlur={handleBlur}
                labelSx={props?.sx?.['.MuiInputLabel-root']}
                {...props}
                value={!regex.test(props?.value?.value) ? props.value : ''}
              >
                <DropdownItem value="true">True</DropdownItem>
                <DropdownItem value="false">False</DropdownItem>
              </DropDown>
            </Box>
          ) : (
            <AutocompleteFreeSolo
              type={type}
              onChange={onChange}
              error={error}
              handleBlur={handleBlur}
              label={label}
              placeholder={placeholder}
              additionalPipelineArguments={{
                Boolean: [
                  ...additionalPipelineArguments?.Boolean,
                  ...boolOptions,
                ],
              }}
              argValue={argValue}
              form={form}
              argIndex={argIndex}
              name="value"
            />
          )}
        </>
      );
    case 'Column':
      return (
        <Autocomplete
          limitTags={2}
          options={
            datasetColumns.length
              ? [
                  SELECT_ALL_COLUMN,
                  ...datasetColumns.filter((col) => col?.column_name !== 'pk'),
                ]
              : []
          }
          multiple
          popupIcon={<DropdownArrow />}
          disableCloseOnSelect
          getOptionLabel={columnGetOptionLabel}
          isOptionEqualToValue={columnIsOptionEqualToValue}
          getOptionDisabled={(option) =>
            option?.column_name === 'No column present'
          }
          renderInput={renderInput}
          renderOption={columnRenderOption}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Box
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
              >
                <Chip
                  key={JSON.stringify(option)}
                  color="primary"
                  label={
                    option?.column_name?.length > 10
                      ? `${option?.column_name.slice(0, 8)}..`
                      : option?.column_name
                  }
                  {...getTagProps({ index })}
                  size="small"
                />
              </Box>
            ))
          }
          // @ts-ignore
          onChange={columnsOnChange}
          {...props}
          value={props?.value && Array.isArray(props.value) ? props.value : []}
          noOptionsText="No dataset variables available"
        />
      );
    case 'Dataset':
      return (
        <Autocomplete
          limitTags={2}
          popupIcon={<DropdownArrow />}
          // @ts-ignore
          onChange={(_event, value) =>
            onChange({
              target: {
                value: value || '',
              },
            })
          }
          disableClearable={['', undefined].includes(
            props?.value?.table_display_name
          )}
          isOptionEqualToValue={isDatastetOptionEqualToValue}
          options={[...allDatasets]}
          getOptionLabel={datasetGetOptionLabel}
          renderOption={datasetRenderOption}
          renderTags={(tagValue, getTagProps) =>
            tagValue?.map((option, index) => (
              <Chip
                key={option?.id}
                label={option?.Name}
                {...getTagProps({ index })}
                size="small"
              />
            ))
          }
          noOptionsText="No dataset available."
          renderInput={renderInput}
          {...props}
          value={props?.value ? props?.value : {}}
        />
      );
    case 'Model':
      return (
        <Autocomplete
          limitTags={2}
          popupIcon={<DropdownArrow />}
          // @ts-ignore
          onChange={(_event, value) => onChange({ target: { value } })}
          options={models}
          disableClearable={['', undefined].includes(props?.value?.model_name)}
          getOptionLabel={utils.getModelOptionLabel}
          isOptionEqualToValue={modelIsOptionEqualToValue}
          renderOption={modelRenderOption}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                key={option.id}
                label={option.model_name}
                {...getTagProps({ index })}
                size="small"
              />
            ))
          }
          noOptionsText="No model available."
          renderInput={renderInput}
          {...props}
          value={props?.value ? props?.value : {}}
          // value={props?.value && Array.isArray(props.value) ? props.value : []}
        />
      );
    case 'ConsoleFiles':
      return (
        <Autocomplete
          limitTags={2}
          popupIcon={<DropdownArrow />}
          // @ts-ignore
          onChange={(_event, value) =>
            onChange({
              target: {
                value: value || '',
              },
            })
          }
          disableClearable={['', undefined].includes(props?.value?.name)}
          options={[
            ...additionalConsoleFilesFromPipelineArguments,
            ...consoleFilesList,
          ]}
          getOptionLabel={consoleFileGetOptionLabel}
          renderOption={consoleFileRenderOption}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                key={option.id}
                label={option.name}
                {...getTagProps({ index })}
                size="small"
              />
            ))
          }
          renderInput={renderInput}
          isOptionEqualToValue={consoleFileIsOptionEqualToValue}
          {...props}
          value={props?.value ? props?.value : {}}
          // value={props?.value && Array.isArray(props.value) ? props.value : []}
          noOptionsText="No console files available"
        />
      );
    default:
      return (
        <TextField
          onChange={onChange}
          name="value"
          onBlur={handleBlur}
          error={error}
          helperText={helperText}
          placeholder={placeholder || 'Enter value'}
          label={label}
          {...props}
        />
      );
  }
}

ConsoleArgumentInput.defaultProps = {
  datasetColumns: [],
  label: '',
  placeholder: '',
  sx: {},
};
ConsoleArgumentInput.propTypes = {
  type: PropTypes.string.isRequired,
  datasetColumns: PropTypes.oneOfType([PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  allDatasets: PropTypes.oneOfType([PropTypes.array]).isRequired,
  consoleFilesList: PropTypes.oneOfType([PropTypes.array]).isRequired,
  models: PropTypes.oneOfType([PropTypes.array]).isRequired,
  value: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  sx: PropTypes.objectOf(PropTypes.any),
  helperText: PropTypes.objectOf(PropTypes.any).isRequired,
  error: PropTypes.objectOf(PropTypes.any).isRequired,
  handleBlur: PropTypes.func.isRequired,
  activeProject: PropTypes.oneOfType([PropTypes.object]).isRequired,
  additionalConsoleFilesFromPipelineArguments: PropTypes.oneOfType([
    PropTypes.array,
  ]).isRequired,
  additionalPipelineArguments: PropTypes.oneOfType([PropTypes.object])
    .isRequired,
  argValue: PropTypes.objectOf(PropTypes.any).isRequired,
  argIndex: PropTypes.number.isRequired,
  form: PropTypes.objectOf(PropTypes.any).isRequired,
};
